import dayjs from 'dayjs';
import { Duration } from 'dayjs/plugin/duration.js';
import { CalendarEntry } from './calendar-entry.js';
import { Cardinal } from './core/cardinal.js';
import { DataModel } from './dto/dto.js';
import { CustomerProfile } from './serializable/customer-profile.js';

export enum SyncEventSource {
  InTime = 'InTime',
  InTimeWeb = 'InTimeWeb',
  InTimeCloud = 'InTimeCloud',
  InTimeBusiness = 'InTimeBusiness',
  InTimeReception = 'InTimeReception',
  InTimeBusinessWeb = 'InTimeBusinessWeb',
  InTimePaymentService = 'InTimePaymentService',
  InTimeScanner = 'InTimeScanner',
}

export interface ISyncEventWithClient {
  client: CustomerProfile;
  clientId: string;
}

export interface ISyncEventWithCalendarEntry {
  calendarEntry: CalendarEntry;
  calendarEntryId: string;
}

export interface ISyncEventWithGroup {
  groupId: string;
  repeatCount: Cardinal;
  repeatInterval: Duration;
  calendarEntry: CalendarEntry;
}

export interface IBusinessSyncEvent {
  creationDate: dayjs.Dayjs;
  businessId: string;
}

export interface ITicketSyncEvent {
  creationDate: dayjs.Dayjs;
  ticketId: string;
}

export abstract class SyncEvent extends DataModel {
  abstract get uniqueId(): string
  abstract get creatorId(): string | null
  abstract get deviceId(): string | null
  abstract get creationDate(): dayjs.Dayjs
  abstract get source(): SyncEventSource
}

export abstract class NotificationEvent extends SyncEvent {
  abstract get seen(): boolean
  abstract markAsSeen(): this;
}
